import jsonp from "assets/js/jsonp";
import { commonParams, options, removePending, REQUEST_PREFIX } from "./config";
import axios from "api/axios";
import Qs from "qs";

const debug =
  process.env.NODE_ENV !== "production" &&
  process.env.NODE_ENV !== "production_testing";

// 获取图片
export function getBanner(params) {
  var url = debug
    ? "/api/UICMS/GetIMGListByAPI"
    : `${REQUEST_PREFIX}/UICMS/GetIMGListByAPI`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: "get",
    params: data
  })
    .then(res => {
      // console.log("res-----------------------", JSON.parse(res.data));
      return Promise.resolve(JSON.parse(res.data));
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
// 获取图片 -- cms图片管理
export function getBannerCMS(params) {
  // var url = debug
  //   ? "/api/UIBOM/MatPinterface"
  //   : `${REQUEST_PREFIX}/UIBOM/MatPinterface`;
  var url = "https://cms.eeidm.com/picture/noAuth/list";
  const data = Object.assign({}, {}, params);
  console.log(data);
  return axios({
    url: url,
    method: "post",
    params: data
  })
    .then(res => {
      console.log(res, "res.rows");
      return Promise.resolve(res.data);
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 点击率
export function IMGClick(params) {
  var url = debug ? "/api/UICMS/IMGClick" : `${REQUEST_PREFIX}/UICMS/IMGClick`;
  const data = Object.assign({}, commonParams, params);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        return Qs.stringify(data);
      }
    ]
  })
    .then(res => {
      return Promise.resolve(JSON.parse(res.data));
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 行业资讯 new
export function MatPinterfaceList(obj) {
  // var url = debug ? '/api/UIBOM/KbomApiGet' : `${REQUEST_PREFIX}/UIBOM/KbomApiGet`;
  var url = "https://server.eeidm.com/api/UIBOM/MatPinterface";
  const data = Object.assign({}, commonParams, obj);
  return axios({
    url: url,
    method: "post",
    data: data,
    transformRequest: [
      function(data) {
        return Qs.stringify(data);
      }
    ],
    other: obj.other
  })
    .then(res => {
      console.log(res);
      return Promise.resolve({
        resData: res.data,
        config: obj
      });
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// 行业资讯   详情
export function GetNewsDetail(obj) {
  var url = debug
    ? "/api/UIBOM/GetNewsDetail"
    : `${REQUEST_PREFIX}/UIBOM/GetNewsDetail`;
  const data = Object.assign({}, commonParams, obj);
  return axios({
    url: url,
    method: "get",
    params: data,
    other: obj.other
  })
    .then(res => {
      return Promise.resolve({
        resData: JSON.parse(
          res.data
            .replace(/[\r]/g, "")
            .replace(/[\n]/g, "")
            .replace(/[\t]/g, "")
        ),
        config: obj
      });
    })
    .catch(err => {
      return Promise.reject(err);
    });
}



// WEBPACK FOOTER //
// ./src/api/banner.js